const RESOURCE_NAME = "entities/permissions";

export default {};
